enum ActionType {
    REQUEST_BASAL_GANGLIA_ENV = '[BASAL_GANGLIA_ENV] GET BASAL_GANGLIA_ENV',
    RECEIVE_BASAL_GANGLIA_ENV = '[BASAL_GANGLIA_ENV] SET BASAL_GANGLIA_ENV',
    SET_ERROR = '[BASAL_GANGLIA_ENV] SET ERROR',
}

export default ActionType
